import React from 'react';
import { useStyle } from '@magento/venia-ui/lib/classify';
import { useWindowSize } from '@magento/peregrine';
import { useUserContext } from '@magento/peregrine/lib/context/user/';
import defaultClasses from './itemSkuInfo.module.css';
import { useAppContext } from '@magento/peregrine/lib/context/app';

var ItemSkuInfo = function ItemSkuInfo(_ref) {
  var itemId = _ref.itemId,
      smartString = _ref.smartString,
      propClasses = _ref.classes,
      product = _ref.product;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isNotLargeDevice = innerWidth < 1280;
  return React.createElement(React.Fragment, null, isNotLargeDevice ? React.createElement("div", {
    className: "mt-[30px] grid grid-cols-12 gap-2.5 text-bronze"
  }, React.createElement("div", {
    className: "col-span-8 text-base leading-normal"
  }, "Configured Item #:"), React.createElement("div", {
    className: "col-span-8 text-base leading-normal"
  }, itemId), React.createElement("div", {
    className: "col-span-12 text-base leading-normal mt-5"
  }, "Smart String:"), React.createElement("div", {
    className: "col-span-12 text-base leading-normal"
  }, smartString)) : React.createElement("div", {
    className: "mt-[30px] grid grid-cols-12 gap-2.5 text-bronze"
  }, React.createElement("div", {
    className: "col-span-4 text-base leading-normal"
  }, "Configured Item #:"), React.createElement("div", {
    className: "col-span-8 text-base leading-normal"
  }, itemId), React.createElement("div", {
    className: "col-span-4 text-base leading-normal "
  }, "Smart String:"), React.createElement("div", {
    className: "col-span-8 text-base leading-normal whitespace-nowrap"
  }, smartString)));
};

export default ItemSkuInfo;